
<div class="d-flex">
  <label class="mr-auto" translate>Input</label>
  <div class="text-muted" translate *ngIf="inputType == 'dir'">This task takes a directory</div>
  <div class="text-muted" translate *ngIf="inputType == 'dirs'">This task takes a list of directories</div>
  <div class="text-muted" translate *ngIf="inputType == 'path'">This task takes a path</div>
  <div class="text-muted" translate *ngIf="inputType == 'paths'">This task takes a list of paths</div>
</div>
<div class="info" *ngIf="inputType == 'dir' || inputType == 'path'">
  <path-selector [(ngModel)]="args.input" (enter)="enter.emit()" required [placeholder]="'Input location'|translate" permissionEnable="tasks:manage"></path-selector>
</div>
<div class="info" *ngIf="inputType == 'dirs' || inputType == 'paths'">
  <entity-list [entities]="args.input">
    <ng-template entityListEmpty>
      <empty-state icon="folder-open" [text]="&quot;No inputs added&quot;|translate">
        <div class="d-inline-flex align-items-center mt-2">
          <button class="btn btn-primary" (click)="showAdd()" permissionEnable="tasks:manage" translate>Add input</button>
          <div class="dropdown ml-3" ngbDropdown *ngIf="vars?.length || suggestVariableInput">
            <button class="btn btn-secondary" ngbDropdownToggle permissionEnable="tasks:manage" translate>Add variable input</button>
            <div ngbDropdownMenu>
              <button class="dropdown-item" ngbDropdownItem *ngIf="suggestVariableInput" (click)="addInputVariable()" translate>Job input</button>
              <ng-container *ngIf="vars">
                <ng-container *ngFor="let v of vars">
                  <button *ngIf="v.key !== &quot;input&quot;" ngbDropdownItem (click)="addVariable(v)">{{v.key}}</button>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </empty-state>
    </ng-template>
    <ng-template entityListItem let-item="entity">
      <div class="list-group-item list-group-item-action combi single"><a class="list-group-main no-wrap" (click)="editInput(item)"><i class="far fa-folder"></i><span>{{item}}</span></a>
        <button class="btn btn-link reveal" (click)="removeInput(item)" permissionEnable="tasks:manage"><i class="far fa-trash-alt"></i><span class="sr-only" translate>Remove</span></button>
      </div>
    </ng-template>
  </entity-list>
  <div class="d-inline-flex align-items-center mt-3" *ngIf="args.input.length &gt; 0">
    <button class="btn btn-secondary" (click)="showAdd()" permissionEnable="tasks:manage"><i class="far fa-plus"></i><span translate>Add input</span></button>
    <div class="dropdown ml-3" ngbDropdown *ngIf="vars?.length">
      <button class="btn btn-secondary" ngbDropdownToggle permissionEnable="tasks:manage" translate>Add variable input</button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem *ngFor="let v of vars" (click)="addVariable(v)">{{v.key}}</button>
      </div>
    </div>
  </div>
</div>